var exports = {
  "iE": "xe533113f--c5c120--wrapper",
  "Kk": "xe533113f--c5c120--icon",
  "DD": "xe533113f--c5c120--title",
  "iU": "xe533113f--c5c120--message",
};

module.exports = exports;
